import { render, staticRenderFns } from "./SHelp.vue?vue&type=template&id=224ef034&scoped=true"
import script from "./SHelp.vue?vue&type=script&lang=js"
export * from "./SHelp.vue?vue&type=script&lang=js"
import style0 from "./SHelp.vue?vue&type=style&index=0&id=224ef034&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224ef034",
  null
  
)

export default component.exports